import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, createVNode as _createVNode, mergeProps as _mergeProps, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue";
const _hoisted_1 = { class: "flex-1 min-w-0 truncate text-left" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createBlock($setup["SelectTrigger"], _mergeProps(_ctx.$attrs, {
        "data-slot": "select-trigger",
        class: $setup.cn('h-9 w-full flex items-center justify-between gap-2 rounded-md border border-input bg-transparent px-3 shadow-xs transition-colors', 'text-sm [&:not([data-placeholder])]:text-en-blue-500 data-[placeholder]:text-muted-foreground', 'focus:outline-none focus-visible:ring-2 focus-visible:ring-ring', 'data-[state=open]:ring-2 data-[state=open]:ring-ring', 'disabled:cursor-not-allowed disabled:opacity-50', $setup.props.class)
    }), {
        default: _withCtx(() => [
            _createElementVNode("span", _hoisted_1, [
                _renderSlot(_ctx.$slots, "default")
            ]),
            _renderSlot(_ctx.$slots, "actions"),
            _createVNode($setup["ChevronsUpDown"], {
                size: 16,
                class: "shrink-0 text-muted-foreground"
            })
        ]),
        _: 3 /* FORWARDED */
    }, 16 /* FULL_PROPS */, ["class"]));
}
